import { MAX_WIDTH } from "@/constants/components";

import { Box, Stack } from "@chakra-ui/react";
import {
  getCdnImageSrc,
  Image,
  useResponsive,
  VStack,
  LARGEL_BUTTON_TYPE,
  LargeButton,
  NextLink,
  responsive,
  colors,
} from "goi_common";
import { ReactNode } from "react";

export default function BenefitSection() {
  const { isBiggerThanLg } = useResponsive();

  return (
    <VStack width="100%" alignItems="center" background={colors.brown850}>
      <Box
        className="head_24_eb lg_head_42_b"
        css={responsive({
          padding: { base: "70px 0 0", lg: "120px 0 40px" },
          color: colors.white,
          textAlign: "center",
        })}
      >
        {/* 100원으로 시작하는 장례 준비
        <br /> 타 상조 대비 절반의 가격으로
        <br className="lg_over_hidden" /> 장례 준비하세요. */}
        단 100원으로 장례를 준비하세요. <br />
        불필요한 비용은 줄이고 <br className="lg_over_hidden" /> 필요한 것만
        남겼습니다
      </Box>

      <Stack
        maxWidth={`${MAX_WIDTH}px`}
        gap={isBiggerThanLg ? "20px" : "20px"}
        css={responsive({
          padding: {
            base: "40px 18px",
            lg: "50px 24px",
          },
          flexDirection: { base: "column", lg: "row" },
          alignItems: { base: "center", lg: "flex-end" },
          scrollMarginTop: "-100px",
        })}
        id="benefit"
      >
        <BenefitItem
          num={1}
          title={"매년 3~5% 오르는 장례비용,\n월 100원으로 가격 보장해드려요."}
          description={<>지금 가입하면 평생 현재 가격으로 이용할 수 있어요.</>}
          btn={{
            text: "100원 상조 자세히 보기",
            href: "/content/feeds/100sangjo/",
          }}
        />
        <BenefitItem
          num={3}
          title={"거품을 없앤 장례,\n가격을 50%로 낮췄어요."}
          description={
            <>
              {/* 비싼 연예인 마케팅, 현장 추가 없이 비용을 획기적으로 낮췄습니다. */}
              가입 부담을 낮추고, 눈에 보이지 않는 비용까지 줄였어요.
            </>
          }
          btn={{
            text: "보장 상품 자세히 보기",
            href: "/service/",
          }}
        />
      </Stack>
    </VStack>
  );
}

function BenefitItem({
  num,
  title,
  btn,
  description,
}: {
  num: number;
  title: string;
  btn: {
    text: string;
    href: string;
  };
  description: ReactNode;
}) {
  return (
    <Stack
      gap="16px"
      justifyContent="space-between"
      background={colors.white}
      css={responsive({
        width: { base: "100%", lg: "50%" },
        borderRadius: "16px",
        padding: { base: "20px", lg: "40px" },
      })}
    >
      <VStack justifyContent="center">
        <VStack borderRadius="16px">
          <Image
            src={getCdnImageSrc(
              num === 3
                ? `direct/home/negative-benefit-3.png`
                : `direct/home/benefit-3-${num}.png`
            )}
            width="100%"
            height="auto"
            alt=""
          />
        </VStack>
        <Box
          className="gray900 subtitle_21_b lg_head_28_b"
          css={responsive({
            whiteSpace: "pre-line",
            padding: { base: "20px 0 12px", lg: "24px 0 16px" },
            color: "#AF7459",
          })}
        >
          {title}
        </Box>

        <Box
          className="gray600 body_16_r lg_subtitle_21_b"
          css={{ wordBreak: "keep-all", color: "#AF7459" }}
        >
          {description}
        </Box>
        <VStack width="100%" alignItems="center" padding="36px 0 0">
          <NextLink
            href={btn.href}
            css={responsive({
              width: "100%",
            })}
            event={{
              newGtm: { path: "home", trigger_and_target: "uv_service" },
            }}
          >
            <LargeButton
              buttonType={LARGEL_BUTTON_TYPE.ORANGE}
              className="subtitle_18_b"
              css={responsive({
                borderRadius: "10px",
                height: { lg: "48px", base: "48px" },
              })}
            >
              {btn.text}
            </LargeButton>
          </NextLink>
        </VStack>
      </VStack>
    </Stack>
  );
}
